/**
 * Utilities for starting the Intuit (QuickBooks Online) OAuth flow.
 *
 * Appends the OIDC `prompt=select_account` parameter to the authorization
 * URL so Intuit shows the account/company chooser instead of silently
 * reusing the SSO session from a previously-connected account.
 */

/**
 * Append `prompt=select_account` to an Intuit OAuth authorization URL,
 * preserving any existing query string.
 *
 * @param {string} oauthUrl - The Intuit OAuth authorization URL.
 * @returns {string} The URL with `prompt=select_account` appended.
 */
const withSelectAccountPrompt = oauthUrl => {
  if (typeof oauthUrl !== 'string' || oauthUrl.length === 0) {
    return oauthUrl;
  }
  if (/[?&]prompt=/.test(oauthUrl)) {
    return oauthUrl;
  }
  const separator = oauthUrl.includes('?') ? '&' : '?';
  return `${oauthUrl}${separator}prompt=select_account`;
};

/**
 * Redirect the current tab to the Intuit OAuth authorization URL with
 * `prompt=select_account` appended to force the account chooser.
 *
 * @param {string} oauthUrl - The Intuit OAuth authorization URL.
 */
export const redirectToIntuitOAuth = oauthUrl => {
  window.location.href = withSelectAccountPrompt(oauthUrl);
};
